import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CopyDialogComponent } from '@client/app/components/copy-dialog/copy-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class CopyDialogService {
    constructor (private ngbModal: NgbModal) {}

    open (copyString: string, headline?: string, cb?: () => void): NgbModalRef {
        const modalRef = this.ngbModal.open(CopyDialogComponent);

        modalRef.componentInstance.resolve = {
            copyString: copyString,
            headline: headline,
        };

        modalRef.componentInstance.close = () => {
            modalRef.close();
        };

        modalRef.result.then(() => {
            if (cb) {
                cb();
            }
        }, () => {
            // Modal dismissed - angular.noop equivalent
        });

        return modalRef;
    }
}
